<template>
  <Dialog :open="open" @update:open="$emit('update:open', $event)">
    <DialogContent class="sm:max-w-lg md:max-w-2xl rounded-lg bg-white shadow-xl p-0 gap-0 top-72" @pointer-down-outside.prevent @interact-outside.prevent>
      <DialogHeader class="flex flex-row items-center justify-between py-4 px-5 border-b border-gray-400">
        <DialogTitle class="text-xl font-medium text-gray-900">
          {{ fullTitle }}
        </DialogTitle>
        <DialogDescription class="sr-only">
          Review impact of disability statement according to the criteria listed below.
        </DialogDescription>
      </DialogHeader>

      <div class="bg-gray-200 border-b border-gray-400 px-5 py-3 text-gray-900">
        Review impact of disability statement according to the following criteria set:
      </div>

      <div class="max-h-96 overflow-y-auto">
        <ul v-if="visibleCriteria.length">
          <li
            v-for="item in visibleCriteria"
            :key="item.label"
            class="px-5 py-4 border-b border-gray-400 last:border-b-0"
          >
            <div class="flex items-start justify-between gap-4">
              <p class="font-medium text-gray-900">{{ item.label }}</p>
              <span class="text-md text-gray-700 shrink-0 mt-0.5">Required</span>
            </div>
            <p class="text-md text-gray-700 mt-1">{{ item.description }}</p>
          </li>
        </ul>
        <p v-else class="px-5 py-4 text-gray-700 italic">
          No review criteria available for the current profile.
        </p>
      </div>

      <DialogFooter class="px-5 py-4 border-t border-gray-400 flex gap-3 justify-end">
        <GbButton gbTheme="grayOutlineSecondary" @click="$emit('update:open', false)">
          Cancel
        </GbButton>
        <GbButton
          gbTheme="aiPrimary"
          :disabled="!visibleCriteria.length"
          @click="$emit('review')"
        >
          <span class="material-icons-outlined text-base mr-1.5" aria-hidden="true">assignment_turned_in</span>
          Review Impact Statement
        </GbButton>
      </DialogFooter>
    </DialogContent>
  </Dialog>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/dialog'
import GbButton from '@/components/GbButton.vue'
import type { CriteriaItem } from '@/content-review/api'

const props = defineProps<{
  open: boolean
  criteria: CriteriaItem[]
  criteriaSetName?: string
  subjects: string[]
  contentLabel?: string
}>()

defineEmits<{
  'update:open': [value: boolean]
  review: []
}>()

const fullTitle = computed(() => {
  const base = props.contentLabel ? `${props.contentLabel} Auto-review` : 'Auto-review'
  return props.criteriaSetName ? `${base} (${props.criteriaSetName})` : base
})

const visibleCriteria = computed(() =>
  props.criteria.filter(
    (item) =>
      item.subjects.length === 0 || item.subjects.some((s) => props.subjects.includes(s))
  )
)
</script>
